import de_DE from "./de_DE";
import en_US from "./en_US";
import es_ES from "./es_ES";
import fr_FR from "./fr_FR";
import pt_BR from "./pt_BR";
import vi_VN from "./vi_VN";
import it_IT from "./it_IT";

const i18n = {
  "pt-BR": pt_BR,
  "de-DE": de_DE,
  "en-US": en_US,
  "es-ES": es_ES,
  "fr-FR": fr_FR,
  "it-IT": it_IT,
  "vi-VN": vi_VN,
};

export default i18n;

export const availableLanguages = Object.keys(i18n).map((lang) => {
  return lang;
});

export const languageLabels: Record<string, string> = {
  "pt-BR": "Português (Brasil)",
  "de-DE": "Deutsch",
  "en-US": "English",
  "es-ES": "Español",
  "fr-FR": "Français",
  "it-IT": "Italiano",
  "vi-VN": "Tiếng Việt",
};
